export default "__VITE_ASSET__Dha8AJBQ__"